import React, { useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function ContactForm() {
  const [formData, setFormData] = useState({
    email: '',
    order_id: '',
    subject: 'I have a question',
    message: '',
    agree_policy: false
  });
  const [file, setFile] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.agree_policy) {
      alert('Please agree to the Privacy Policy and Terms and Conditions.');
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('email', formData.email);
      fd.append('order_id', formData.order_id);
      fd.append('subject', formData.subject);
      fd.append('message', formData.message);
      fd.append('agree_policy', formData.agree_policy);
      if (file) fd.append('file', file);

      const res = await fetch(`${BACKEND_URL}/api/contact`, {
        method: 'POST',
        body: fd
      });
      if (res.ok) {
        setSuccess(true);
        setFormData({ email: '', order_id: '', subject: 'I have a question', message: '', agree_policy: false });
        setFile(null);
        setTimeout(() => setSuccess(false), 5000);
      }
    } catch (err) {
      console.error('Contact form error:', err);
    }
    setLoading(false);
  };

  const subjects = [
    'I have a question',
    'I want to order, my sample is not on the site',
    'We want to test as a group (Group testing)',
    'I want to add details about my order',
    'Expedited testing request',
    'Question regarding results',
    'Shipping issue',
    'Payment issue',
    'Public Report Request'
  ];

  return (
    <section className="contact-section" id="contact-us" data-testid="contact-section">
      <div className="container">
        <div className="contact-inner">
          <div className="contact-form-wrapper">
            <h1>Contact Us</h1>
            <h3>Get in Touch with Us</h3>
            <h5>Need assistance with an order, sample submission, or test results? Our team is here to help!</h5>

            {success && (
              <div className="form-success" data-testid="contact-success">
                Your message has been sent successfully! We will get back to you soon.
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Your email address:</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    data-testid="contact-email"
                  />
                </div>
                <div className="form-group">
                  <label>Your Order ID (optional):</label>
                  <input
                    type="text"
                    name="order_id"
                    value={formData.order_id}
                    onChange={handleChange}
                    data-testid="contact-order-id"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Choose your subject or issue:</label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  data-testid="contact-subject"
                >
                  {subjects.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Your message:</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  data-testid="contact-message"
                />
              </div>

              <div className="form-checkbox">
                <input
                  type="checkbox"
                  name="agree_policy"
                  checked={formData.agree_policy}
                  onChange={handleChange}
                  data-testid="contact-agree"
                />
                <span>
                  I agree to the <a href="#">Privacy Policy</a> and <a href="#">Terms and Conditions</a>.
                </span>
              </div>

              <div className="form-group">
                <label>File Upload</label>
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  data-testid="contact-file"
                />
              </div>

              <button type="submit" className="btn-submit" disabled={loading} data-testid="contact-submit">
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
          <div className="contact-image">
            <img
              src="/img/support.jpg"
              alt="Contact the Kovar Analytics customer support team for testing enquiries" loading="lazy" decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
